// Endpoints de gestão de templates WhatsApp (tag 'WhatsappTemplate' em lib/api).
//
// 🔴 Nomes prefixados com `WhatsappTemplate` de propósito. O `api` base é ÚNICO e
// dois endpoints com o mesmo nome colidem em SILÊNCIO — o segundo sobrescreve o
// primeiro sem erro de build. `getTemplates`/`getStoreTemplates` já existem no inbox
// e o CRM tem os seus de campanha; um `listTemplates` aqui seria a terceira família
// de "templates" do app.
import { api } from '@/lib/api';
import type { CreateTemplateInput, TemplatesListResponse, WhatsappTemplate } from './model';

export const templatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    listWhatsappTemplates: build.query<TemplatesListResponse, void>({
      query: () => '/templates',
      providesTags: (result) =>
        result
          ? [
              ...result.items.map((t) => ({ type: 'WhatsappTemplate' as const, id: t.id })),
              { type: 'WhatsappTemplate' as const, id: 'LIST' },
            ]
          : [{ type: 'WhatsappTemplate' as const, id: 'LIST' }],
    }),

    createWhatsappTemplate: build.mutation<WhatsappTemplate, CreateTemplateInput>({
      query: (body) => ({ url: '/templates', method: 'POST', body }),
      // Invalida também 'Template': o seletor do inbox mostra os aprovados, e um
      // template novo muda o que estará disponível lá assim que a Meta aprovar.
      invalidatesTags: [{ type: 'WhatsappTemplate', id: 'LIST' }, 'Template'],
    }),

    deleteWhatsappTemplate: build.mutation<void, string>({
      query: (id) => ({ url: `/templates/${id}`, method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'WhatsappTemplate', id },
        { type: 'WhatsappTemplate', id: 'LIST' },
        'Template',
      ],
    }),

    /** Reconcilia com a WABA — traz o que foi criado direto no WhatsApp Manager. */
    syncWhatsappTemplates: build.mutation<TemplatesListResponse, void>({
      query: () => ({ url: '/templates/sync', method: 'POST' }),
      invalidatesTags: [{ type: 'WhatsappTemplate', id: 'LIST' }, 'Template'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListWhatsappTemplatesQuery,
  useCreateWhatsappTemplateMutation,
  useDeleteWhatsappTemplateMutation,
  useSyncWhatsappTemplatesMutation,
} = templatesApi;
